var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router-dom";
import { keys } from "ramda";
import bg from "../../img/modinet_left_side-002.jpg";
import { WebSocketMessage } from "../../serverConnection";
import InputField from "../common/InputField";
import Spinner from "../common/Spinner";
var Invite = /** @class */ (function (_super) {
    __extends(Invite, _super);
    function Invite() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            validatedToken: false,
            password: "",
            repeat: "",
            errors: {}
        };
        _this.render = function () {
            if (!_this.state.validatedToken) {
                return React.createElement(Spinner, null);
            }
            return React.createElement("div", { className: "container" },
                React.createElement("img", { src: bg, className: "bg", alt: "" }),
                React.createElement("div", { style: { display: "flex", flexDirection: "column", height: "100vh", justifyContent: "center" } },
                    React.createElement("div", null,
                        React.createElement("form", { onSubmit: function (e) { e.preventDefault(); } },
                            React.createElement("div", { className: "card-panel" },
                                React.createElement(InputField, { type: "password", label: "Password", placeholder: "Protect your password...", value: _this.state.password, onChange: function (password) { return _this.setState({ password: password }, _this.validate); }, meta: { touched: _this.state.password.length > 0, error: _this.state.errors.password } }),
                                React.createElement(InputField, { type: "password", label: "Confirm Password", placeholder: "...like your toothbrush", value: _this.state.repeat, onChange: function (repeat) { return _this.setState({ repeat: repeat }, _this.validate); }, meta: { touched: _this.state.repeat.length > 0, error: _this.state.errors.repeat } })),
                            React.createElement(Link, { to: "/login", className: "red btn-flat left white-text" }, "Cancel"),
                            React.createElement("button", { className: "green right btn-flat white-text", disabled: keys(_this.state.errors).length > 0, onClick: function () { return _this.handleFormSubmit(); } }, "Accept")))));
        };
        _this.validate = function () {
            var errors = {};
            if (_this.state.password.length < 8) {
                errors.password = "Your password has to be 8 characters";
            }
            if (_this.state.repeat !== _this.state.password) {
                errors.repeat = "Passwords must match";
            }
            _this.setState({ errors: errors });
        };
        return _this;
    }
    Invite.prototype.componentDidMount = function () {
        this.props.send(WebSocketMessage("login", "token", this.props.match.params.token));
    };
    Invite.prototype.shouldComponentUpdate = function (props) {
        if (props.responses.has("Validated " + this.props.match.params.token)
            && !this.state.validatedToken) {
            this.setState({ validatedToken: true });
        }
        return true;
    };
    Invite.prototype.handleFormSubmit = function () {
        this.props.send(WebSocketMessage("login", "store", { token: this.props.match.params.token, password: this.state.password }));
        this.props.history.push("/login");
    };
    return Invite;
}(Component));
export default withRouter(Invite);



//////////////////
// WEBPACK FOOTER
// ./src/components/auth/Invite.tsx
// module id = 1283
// module chunks = 0